import {Building} from "../Building";
import {BufferGeometry, Mesh, Object3D} from "three";

export interface RoofSideConfig
{
	building: Building;
	external_geometry: BufferGeometry;
	internal_geometry: BufferGeometry;
	overhang_geometry: BufferGeometry;
	overhang_end_geometry: BufferGeometry;
}

/**
 * Represents a side (left or right) of the Roof.
 */
export class RoofSide
{
	public config: RoofSideConfig;

	public container: Object3D;

	private _external: Mesh;
	private _internal: Mesh;

	constructor(config: RoofSideConfig)
	{
		this.config = config;
		this.init();
	}

	private init()
	{
		const materials = this.config.building.materials;

		this._external = new Mesh(this.config.external_geometry, materials.roof_singleSided);
		this._internal = new Mesh(this.config.internal_geometry, materials.interior);

		this._external.name = "externalRoof";
		this._internal.name = "internalRoof";

		this._external.castShadow = true;

		this.container = new Object3D();
		this.container.add(this._external);
		this.container.add(this._internal);
	}

	public add(parent: Object3D)
	{
		parent.add(this.container);
	}

	public update(scale_length: number, scale_width: number)
	{
		this._external.scale.z = scale_length;
		this._internal.scale.z = scale_length;

		this._external.scale.y = scale_width;
		this._internal.scale.y = scale_width;
	}
}